import React, { useEffect, useState, useContext } from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import AllInventory from "../Inventory/AllInventoty";
import { AuthContext } from "../../context/AuthContext";
import { Loader } from "../../components/Loader";
import {
  addRepairedInventory,
  subscribeToRawInventory,
  subscribeToRepairedInventory,
} from "../../network/api/firebaseApi";
import ImagineDialog from "../../components/common/ImagineDialaog";
import EditRawGoods from "../../components/EditFormDialog";
import { convertTimestampToDateTime } from "../../utils/ProductStatus";
import SoldInventory from "../Inventory/SoldInventory";
import TransferedForBilling from "../Inventory/TransferedForBilling";
import Slide from '@mui/material/Slide';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import TextField from '@mui/material/TextField';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function BasicTabs() {
  const [value, setValue] = useState(0);
  const { loading, user, getUserPermissions } = useContext(AuthContext);
  const [userPermissions, setUserPermissions] = useState(null);

  useEffect(() => {
    const fetchUserRole = async () => {
      if (user) {
        try {
          const role = await getUserPermissions(user.uid);
          setUserPermissions(role);
        } catch (error) {
          setUserPermissions([]);
        }
      }
    };
    fetchUserRole();
  }, [user, getUserPermissions]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  if (loading || userPermissions === null) {
    return <Loader />;
  }

  return (
    <Box sx={{ width: "100%", backgroundColor: "black", color: "white", minHeight: "100vh" }}>
      <Box sx={{ borderBottom: 1, borderColor: "red" }}>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="basic tabs example"
          TabIndicatorProps={{ style: { backgroundColor: "red" } }}
          sx={{
            "& .MuiTab-root": {
              color: "white",
              fontWeight: "bold",
              width: "13em",
              "&.Mui-selected": { color: "red", width: "8em" },
            },
          }}
        >
          {userPermissions?.includes("View Raw Inventory") && <Tab label="Raw Goods" {...a11yProps(0)} />}
          {userPermissions?.includes("View Repaired Inventory") && <Tab label="In Progress" {...a11yProps(1)} />}
          {userPermissions?.includes("View Main Inventory") && <Tab label="Ready" {...a11yProps(2)} />}

         <Tab label="Sold" {...a11yProps(3)} />
          <Tab label="Transferred for Billing" {...a11yProps(4)} />
        </Tabs>
      </Box>

      <Box>
        {userPermissions.includes("View Raw Inventory") && (
          <CustomTabPanel value={value} index={0}>
            <BasicMenu userPermissions={userPermissions} isRaw={true} />
          </CustomTabPanel>
        )}
        {userPermissions.includes("View Repaired Inventory") && (
          <CustomTabPanel value={value} index={1}>
            <BasicMenu userPermissions={userPermissions} isRaw={false} />
          </CustomTabPanel>
        )}
        {userPermissions.includes("View Main Inventory") && (
          <CustomTabPanel value={value} index={2}>
            <AllInventory />
          </CustomTabPanel>
        )}
        <CustomTabPanel value={value} index={3}>
          <SoldInventory />
        </CustomTabPanel>
        <CustomTabPanel value={value} index={4}>
          <TransferedForBilling />
        </CustomTabPanel>
      </Box>
    </Box>
  );
}

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3, color: "white" }}>{children}</Box>}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

function BasicMenu({ isRaw, userPermissions }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const [filterType, setFilterType] = useState("All");
  const [products, setProducts] = useState([]);
  const [error, setError] = useState(null);
  const [showDialog, setShowDialog] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [assignOpen, setAssignOpen] = useState(false);
  const [inputValue, setInputValue] = useState('');
  const open = Boolean(anchorEl);

  useEffect(() => {
    const unsubscribe = isRaw
      ? subscribeToRawInventory(({ products, error }) => {
          setProducts(products);
          setError(error);
        })
      : subscribeToRepairedInventory(({ products, error }) => {
          setProducts(products);
          setError(error);
        });
    return () => unsubscribe();
  }, [isRaw]);

  const handleClick = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);
  const handleFilter = (type) => {
    setFilterType(type);
    handleClose();
  };

  const filteredProducts = filterType === "All" ? products : products.filter((product) => product.category === filterType);

  const handleOpenDialog = (product) => {
    setSelectedProduct(product);
    setShowDialog(true);
  };
  const handleCloseDialog = () => setShowDialog(false);

  const handleRepairedSubmit = async ({ formData, uid }) => {
    const { brand, model, category, variant, quality, notes, comment, imei_1, imei_2 } = formData;
    if (!formData || !brand || !model || !category || !variant || !quality || !imei_1) {
      alert("All fields are required!");
      return;
    }
    const isValidIMEI = (imei) => /^\d{15}$/.test(imei);
    if (!isValidIMEI(imei_1) || (imei_2 && !isValidIMEI(imei_2))) {
      alert("IMEI must be exactly 15 digits.");
      return;
    }
    console.log("All Products tab",formData);
    try {
      const result = await addRepairedInventory(uid, formData);
      if (result.error) alert(result.error);
      else {
        alert(result.success);
        setShowDialog(false);
      }
    } catch (error) {
      console.error("Error during submission:", error);
      alert("An unexpected error occurred. Please try again.");
    }
    setShowDialog(false);
  };

  const handleAssignOpen = () => setAssignOpen(true);
  const handleAssignClose = () => {
    setAssignOpen(false);
    setInputValue('');
  };
  const handleAssignSave = () => {
    console.log('Assigned to:', inputValue);
    setAssignOpen(false);
    setInputValue('');
  };
  const handleInputChange = (event) => setInputValue(event.target.value);

  if (error) return <div>Error: {error.message}</div>;

  return (
    <>
      <div>
        <Button
          id="basic-button"
          aria-controls={open ? "basic-menu" : undefined}
          aria-haspopup="true"
          aria-expanded={open ? "true" : undefined}
          onClick={handleClick}
          sx={{
            backgroundColor: "red",
            color: "white",
            padding: "10px 20px",
            borderRadius: "5px",
            textTransform: "none",
            fontWeight: "bold",
            border: "1px solid gray",
            width: "fit-content",
            "&:hover": { backgroundColor: "#b70603" },
          }}
        >
          Filter ({filterType})
        </Button>
        <Menu
          id="basic-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          MenuListProps={{ "aria-labelledby": "basic-button" }}
          sx={{
            "& .MuiPaper-root": { backgroundColor: "white", color: "black" },
            "& .MuiMenuItem-root": { "&:hover": { backgroundColor: "#c7c5c1" } },
          }}
        >
          <MenuItem onClick={() => handleFilter("All")}>All</MenuItem>
          <MenuItem onClick={() => handleFilter("I1")}>I1</MenuItem>
          <MenuItem onClick={() => handleFilter("I2")}>I2</MenuItem>
          <MenuItem onClick={() => handleFilter("I3")}>I3</MenuItem>
          <MenuItem onClick={() => handleFilter("I4")}>I4</MenuItem>
          <MenuItem onClick={() => handleFilter("I5")}>I5</MenuItem>
        </Menu>

        <div style={{ marginTop: "20px" }}>
          {filteredProducts.length > 0 ? (
            [...new Set(filteredProducts.map((product) => product.brand))].map((brand, index) => (
              <div key={index}>
                <h1 className="bg-red-600 w-full h-10 flex justify-center items-center rounded-md text-xl">
                  {brand}
                </h1>
                <div className="overflow-x-scroll flex p-6 m-5">
                  {filteredProducts
                    .filter((product) => product.brand === brand)
                    .map((product) => (
                      <ProductCard
                        onView={() => handleOpenDialog(product)}
                        key={product.id}
                        product={product}
                        assignProduct={handleAssignOpen}
                      />
                    ))}
                </div>
              </div>
            ))
          ) : (
            <p>No products available.</p>
          )}
        </div>
      </div>
      <ImagineDialog
        open={showDialog}
        onClose={handleCloseDialog}
        dialogContent={
          <EditRawGoods
            onValidateAndSubmit={handleRepairedSubmit}
            product={selectedProduct}
            isRaw={isRaw}
            onClose={handleCloseDialog}
            userPermissions={userPermissions}
          />
        }
        dialogActions={<Button onClick={handleCloseDialog}>Cancel</Button>}
      />
      <Dialog
        open={assignOpen}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleAssignClose}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle>{"Enter Your Information"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            Please provide the Engineer Name Here
          </DialogContentText>
          <TextField
            autoFocus
            margin="dense"
            id="input-field"
            label="Engineer Name to Assign"
            type="text"
            fullWidth
            variant="standard"
            value={inputValue}
            onChange={handleInputChange}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleAssignClose}>Cancel</Button>
          <Button onClick={handleAssignSave}>Save</Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

const ProductCard = ({ product, onView, assignProduct }) => {
  const productDetails = [
    { label: "Model", value: product.model },
    { label: "Category", value: product.category },
    { label: "Variant", value: product.variant },
    { label: "Quantity", value: product.quantity },
    { label: "IMEI 1", value: product.imei_1 },
    { label: "IMEI 2", value: product.imei_2 },
    // { label: "Notes", value: product.comment },
    {label : "Engineer", value:product.qcBy}
  ];

  return (
    <div className="border-[1px] border-red border-solid px-5 py-2 mx-5 text-md bg-white text-black rounded-md">
      <div className="flex justify-between">
        <h3><strong>Brand:</strong> {product.brand}</h3>
        <div>
          {product.quality && (
            <div className="flex items-center font-serif">
              <span className="ml-1">QC: </span>
              <span className="bg-yellow-400 rounded-full px-2 py-1">{product.quality}</span>
            </div>
          )}
          <div className="flex items-center font-serif">
            <span className="ml-1">PD:</span>
            <span className="bg-red-400 rounded-full px-2 py-1">{product.category}</span>
          </div>
        </div>
      </div>
      {productDetails.map(({ label, value }, index) => value && (
        <p key={index}><strong>{label}:</strong> {value}</p>
      ))}
      <p>
        <strong>{product.updatedAt ? "Updated On:" : "Created On:"}</strong>{" "}
        {product.updatedAt ? convertTimestampToDateTime(product.updatedAt) : convertTimestampToDateTime(product.createdAt)}
      </p>
      <div className="flex">
        <button
          onClick={onView}
          className="mt-2 bg-red-500 text-white rounded px-3 py-1 hover:bg-red-600 mr-1"
        >
          View Details
        </button>
        {/* <button
          onClick={assignProduct}
          className="mt-2 bg-red-500 text-white rounded px-3 py-1 hover:bg-red-600 ml-1"
        >
          Assign To
        </button> */}
      </div>
    </div>
  );
};